module.exports = __webpack_public_path__ + "static/media/customerloan.2060249e.svg";